<template>
  <div>
    <div class="album-block clearfix">
      <div class="album-thumbnail">
        <div class="album-responsive">
          <div class="album-sizer">
            <div
              class="album-image"
              :style="{
                backgroundImage: 'url(' + props_img + ')',
              }"
            ></div>
          </div>
        </div>
        <div class="album-photo-count">
          <span>{{ props_num }}</span>
        </div>
      </div>
    </div>
    <div class="album-info p-3">
      <div class="album-title mb-2">
        {{ props_title }}
      </div>
      <span class="album-user" v-if="props_author">{{ props_author }}</span>
      <span class="album-upload-date">{{ props_date }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    props_img: { Type: String, default: "" },
    props_title: { Type: String, default: "" },
    props_author: { Type: String, default: "" },
    props_date: { Type: String, default: "" },
    props_num: { Type: Number, default: "" },
  },
  data() {
    return {};
  },
};
</script>

<style scoped>
.video-title {
  position: relative;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  white-space: normal;
  word-break: break-word;
  /*font-size: 1rem;*/
  line-height: 1.25rem;
  width: 100%;
  height: 2.5rem;
}

.article-upload-date {
  color: #757575;
  font-size: 0.875rem;
  width: 100%;
}

.album-info {
  background-color: white;
}
</style>


// WEBPACK FOOTER //
// src/components/Album/singleCollection.vue